<template>
<v-card flat >
  <vuex-loader :request-id='reqId' ></vuex-loader>
  <v-card-title
    class='subheading py-0 pl-0' >
    <v-btn :loading='noteRequest.loading' @click='getNotes' small icon >
      <v-icon small>replay</v-icon>
    </v-btn>
    <!-- {{notes.length}} Notes since {{ dateformat(notes[notes.length - 1].created_date) }} -->
    <span v-if='notes && notes.length > 0' >
    {{ $tc('summary', notes.length, { count: notes.length, date: dateformat(notes[notes.length - 1].created_date) }) }}
    </span>
    <!-- <span v-else >No notes</span> -->
    <v-spacer/>
    <slot name='toolbar-buttons' ></slot>
  </v-card-title>

  <v-divider></v-divider>
  <v-btn
    v-if='withAdd'
    @click="selectedNote=null; showNotes = true"
    fab absolute top right small color='primary' ><v-icon>add</v-icon></v-btn>
  <v-dialog
    v-if='clientId'
    v-model='showNotes'
    fullscreen >
    <v-card>
      <!-- @note:save='showNotes=false' -->
      <notes
        v-model='selectedNote'
        :client='client'
        @note:deleted='getNotes();showNotes=false'
        @close='showNotes=false' ></notes>
    </v-card>
  </v-dialog>

  <tombstone v-if='noteRequest.loading' ></tombstone>
  <template v-else >
    <v-timeline
      v-if='notes && notes.length > 0'
      align-top dense >
      <v-timeline-item
        v-for='(note, index) in notesToShow'
        :key='`note-${note.id}-${index}`'
        color="pink" small >
        <v-layout pt-3 row wrap>
          <v-btn absolute small right fab flat text
            :disabled='!canEdit(note)'
            @click="selectedNote=note; showNotes = true" >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-flex xs12 sm3>
            <strong>{{ dateformat(note.date) }}</strong><br/>
            <small>created {{ dateformat(note.created_date) }}</small><br/>
            <!-- <small>created by -->
            <practitioner-faces :practitioner-ids="note.owners" :size='18' >
              <small class='caption' >created by</small>
            </practitioner-faces>
            <!-- </small> --><br/>
            <space-faces :size=16
              v-if='note.spaces && note.spaces.length > 0'
              :space-ids="note.spaces" >
              <span slot='prepend' class='caption' >shared with</span>
              <!-- <v-avatar slot='prepend' :size='16' >
                <v-icon small >share</v-icon>
              </v-avatar> -->
            </space-faces>
            <v-chip v-else color="amber" label class='v-chip--x-small' >Private</v-chip>
          </v-flex>
          <v-flex xs12 sm9 >
            <strong>{{note.title}}</strong><br/>
            <div class='mt-2' v-html="markdown(note.text)" ></div>
            <object-chip small
              v-for='obj in note.object_ids'
              :key='`obj-${obj}`' class='ml-0'
              :object='obj' >
            </object-chip>
            <!-- <v-chip v-for='space in note.spaces' :key='space' >{{space}}</v-chip> -->

            <v-menu v-if='note.documents && note.documents.length > 0' offset-y >
              <template v-slot:activator="{ on }">
                <v-chip v-on='on' slot='activator' small icon >
                  Files
                  <v-icon >keyboard_arrow_down</v-icon>
                </v-chip>
              </template>
              <v-list v-if='note && note.documents' dense class='pa-0' >
                <v-list-tile
                  :href='doc.file' target='_blank'
                  v-for='doc in note.documents' :key='doc.name' >
                  <v-list-tile-content>
                    <v-list-tile-title>{{doc.name}}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar >
                    <v-icon small >open_in_new</v-icon>
                  </v-list-tile-avatar>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-timeline-item>
    </v-timeline>
    <v-card-actions v-if='notesExist' >
      <v-btn
        @click='numNotesToShow += pageSize'
        :disabled="!areMoreNotesToShow"
        flat small >Load more</v-btn>
      <!-- <v-pagination
        v-model="page"
        :length="pageCount" ></v-pagination> -->
    </v-card-actions>
    <v-card flat v-else >
      <v-card-text>
        No notes found.
        <v-btn @click='getNotes' flat small >Reload</v-btn>
        <v-btn
          v-if='withAdd'
          @click="selectedNote=null; showNotes = true"
          color='primary' outline outlined small >
          <v-icon>add</v-icon>
          New note
        </v-btn>
      </v-card-text>
    </v-card>
  </template>

  <!-- <time-line :items='notes' v-if='notes && notes.length > 0' >
    <v-btn @click='getNotes' fab absolute bottom left small ><v-icon>replay</v-icon></v-btn>
  </time-line> -->
</v-card>
</template>
<script>
import ObjectChip from '@/components/ObjectChip'
import Notes from '@/components/appointment/edit/Notes'
import Tombstone from '@/components/app/Tombstone'
import SpaceFaces from '@/components/lists/SpaceFaces.vue'
import PractitionerFaces from '@/components/lists/PractitionerFaces.vue'
import marked from 'marked'
import {
  NOTE_SAVE_REQ
} from '@/store/constants'

export default {
  name: 'NoteList',
  components: {ObjectChip, Notes, Tombstone, SpaceFaces, PractitionerFaces},
  props: {
    value: { type: Object, default: () => { return {} } },
    // appointmentId: { required: false },
    client: { required: false },
    relationshipId: { required: false, type: Number },
    // appointment: { required: false },
    touch: { type: Number, default: 0 },
    withAdd: { type: Boolean, default: true },
    withDescription: { type: Boolean, default: true },
    emptyText: { type: String, default: 'No notes for this appointment' }
  },
  data () {
    return {
      // page: 1,
      showNotes: false,
      selectedNote: null,
      pageSize: 5,
      expanded: true,
      numNotesToShow: 5,
      reqId: 'appointment-notes-list-request'
    }
  },
  mounted () {
    if (this.value) {
      this.appointment = this.value
      this.getNotes()
    }
  },
  watch: {
    value () {
      if (this.value) { this.appointment = this.value }
    },
    expanded () {
      if (this.expanded === true) {
        this.getNotes()
      }
    },
    touch () {
      this.getNotes()
    },
    appointmentId () {
      if (this.appointmentId) { this.getNotes() }
    },
    clientId () {
      if (this.clientId) { this.getNotes() }
    },
    noteSaveRequestStatus () {
      if (this.noteSaveRequestStatus === 200 ||
          this.noteSaveRequestStatus === 201) {
        this.getNotes()
      }
    }
  },
  computed: {
    appointmentId () {
      if (this.appointment) {
        return this.appointment.id
      }
    },
    clientId () {
      if (this.client) {
        return this.getObjectPath(this.client, 'client.id')
      }
    },
    noteSaveRequest () {
      return this.$store.getters.getRequestById(NOTE_SAVE_REQ, true)
    },
    noteSaveRequestStatus () {
      return this.noteSaveRequest.status
    },
    noteRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    notes () {
      return this.getObjectPath(this.noteRequest, 'result.data.results', [])
    },
    notesExist () {
      return this.notes && this.notes.length > 0
    },
    notesToShow () {
      if (this.notesExist) {
        return this.notes.slice(0, this.numNotesToShow)
      }
      return []
    },
    areMoreNotesToShow () {
      if (this.notesExist) {
        return this.numNotesToShow <= this.notes.length
      }
      return false
    }
    // pagedNotes () {
    //   let start = (this.page - 1) * this.pageSize
    //   let end = start + this.pageSize
    //   return this.notes.slice(start, end)
    // },
    // pageCount () {
    //   return Math.ceil(this.notes.length / this.pageSize)
    // }
  },
  methods: {
    canEdit (note) {
      console.log(note)
      if (note.owners) {
        let owners = note.owners.map((owner) => { return parseInt(owner) })
        let meId = parseInt(this.meId)
        console.log(owners, meId)
        return owners.indexOf(meId) > -1
      }
      return false
    },
    isNewDate (note, notes, index) {
      if (index > 0) {
        let format = 'YYYY-MM-DD'
        return (this.dateformat(note.created_date, format) !==
                this.dateformat(notes[index - 1].created_date, format))
      }
      return true
    },
    markdown (text) {
      marked.setOptions({sanitize: true})
      return marked(text)
    },
    getNotes () {
      let params = {}
      let hasFilter = false
      if (this.appointment && this.appointment.id) {
        params.objects_appointment = this.appointment.id
        hasFilter = true
      }
      // if (this.clientId) {
      //   params.objects_client = this.clientId
      //   hasFilter = true
      // }
      if (this.relationshipId) {
        params.relationship_id = this.relationshipId
        hasFilter = true
      }
      if (hasFilter) {
        this.$metadataguru
          .resource('notes')
          .id(this.reqId)
          .list(params)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        summary: '{count} note since {date}|{count} notes since {date}'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// NoteList.vue?540ee6e0